/*
 * @Author: wang_shuai 591372242@qq.com
 * @Date: 2022-10-18 09:55:10
 * @LastEditors: wang_shuai 591372242@qq.com
 * @LastEditTime: 2024-10-16 17:03:37
 * @FilePath: \ngs_share_login\src\api\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
import { Loading, Message } from 'element-ui'
import router from '../router'

// create an axios instance
let _baseUrl = process.env.NODE_ENV === 'production' ? window.location.origin + process.env.VUE_APP_BASE_URL : process.env.VUE_APP_BASE_URL
const service = axios.create({
	baseURL: _baseUrl,
	timeout: 15000 // request timeout
})

let loadingInstance = null

// 请求拦截器
service.interceptors.request.use(
	config => {
		// console.log(config)
		config.loading = true

		if (config.requestConfig) {
			if (config.requestConfig.timeout) {
				config.timeout = config.requestConfig.timeout
			}
			config.loading = config.requestConfig.loading
		}
		if (config.loading) {
			loadingInstance = Loading.service({
				lock: true,
				text: '数据加载中，请稍后...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.4)'
			})
		}

		if (bmStorage.sessionStorage.get('token')) {
			config.headers['token'] = bmStorage.sessionStorage.get('token')
		}

		return config
	},
	err => {
		if (loadingInstance) loadingInstance.close()
		Message.error('请求错误')
		return Promise.reject(err)
	}
)

// 返回状态判断(添加响应拦截器)
service.interceptors.response.use(
	res => {
		// console.log(res)
		if (loadingInstance) loadingInstance.close()
		if (res.data.code !== 0) {
			Message.error(res.data.msg ? res.data.msg : '无')
			return Promise.reject('接口错误, code: ' + res.data.code)
		}
		return res.data
	},
	err => {
		if (loadingInstance) loadingInstance.close()
		return Promise.reject(err)
	}
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js